import Collapse from './collapse'

export default Collapse


// WEBPACK FOOTER //
// ./src/components/base/collapse/index.js